module.exports = __webpack_public_path__ + "static/media/nus-logo.db13ee9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/logo/nus-logo.png
// module id = 947
// module chunks = 0